<template>
  <div class="pt-2">
    <v-layout class="">
      <v-flex xs2 class="subheading font-weight-bold">

        <!--
        <c-metric-selector
        :inventoryItemID="definition.id" 
        :realValue="item.quantity"
        :key="definition.id"
        :prefferedSid="prefferedSid"
        labelMode
        ></c-metric-selector>
        -->

        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.quantity"
        :key="item.definition.id"
        :prefferedSid="prefferedSid"
        labelMode
        ></c-ms-ii>
      </v-flex>
      <v-flex xs10 class="subheading font-weight-bold text-uppercase">
        {{ item.definition.name }}
      </v-flex>
    </v-layout>
    <v-layout v-for="batch of mergedBatches"
    :key="batch.id">
      <v-flex offset-xs0>
        <v-layout align-center class="text--text text--darken-1">
          <v-flex xs2 class="c-flex-r1 align-center">
            <v-icon color="grey" small class="ml-2 mr-2">mdi-arrow-right</v-icon>
            <!--
            <c-metric-selector
            :inventoryItemID="definition.id" 
            :realValue="batch.quantity"
            :key="batch.id"
            :prefferedSid="prefferedSid"
            labelMode
            ></c-metric-selector>
            -->

            <c-ms-ii
            :metric_definition="batch.definition" 
            :realValue="batch.quantity"
            :key="batch.id"
            :prefferedSid="prefferedSid"
            labelMode
            ></c-ms-ii>

          </v-flex>
          <v-flex xs4 class="c-flex-r1 align-center">
            <v-icon color="grey">mdi-barcode</v-icon>
            <span class="ml-2">{{ batch.batch_number || 'batch number not set'}}</span>
          </v-flex>
          <v-flex xs4 class="c-flex-r1 align-center">
            <router-link
            v-if="batch.archive_id"
            class="rlink-hover green--text"
            style="text-decoration: none;display:inline-flex;align-items: center;"
            :to="{ path: '/trace/' + batch.archive_id}" @click.native.stop>
              <v-icon small color="green"
              style="transition: none;">mdi-qrcode-scan</v-icon>
              <span class="ml-1">{{ batch.archive_id }}</span>
            </router-link>
      
            <v-chip outlined class="overline ml-4" v-if="batch.internal_code">
              Internal code: {{ batch.internal_code }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="underline mt-2"></div>
  </div>
</template>

<script>
export default {
  props: ['item', 'prefferedSid'],
  computed: {
    mergedBatches () {
      var retDict = {}
      this.item.batches.forEach(item => {
        var pointer = retDict[item.archive_id]
        if (pointer) {
          pointer.quantity += item.quantity
        } else {
          retDict[item.archive_id] = {
            archive_id: item.archive_id,
            quantity: item.quantity,
            batch_number: item.batch_number,
            internal_code: item.internal_code,
            definition: item.definition
          }
        }
      })
      return Object.values(retDict)
    }
  }
}
</script>

<style scoped>
.underline {
  border-bottom: 1px solid var(--v-hline-base);
}
</style>

